import { call, put, takeLatest } from "redux-saga/effects";
import {
  addContact,
  addNewVendor,
  fetchOneVendor,
  fetchVendors,
  updateContact,
  updateVendor,
} from "./vendorApi";

import {
  getVendorsStart,
  getVendorsSuccess,
  getVendorsFailure,
  updateVendorStart,
  updateVendorSuccess,
  updateVendorFailure,
  addContactSuccess,
  addContactFailure,
  addContactStart,
  getVendorOneSuccess,
  getVendorOneFailure,
  getVendorOneStart,
  updateContactFailure,
  updateContactSuccess,
  updateContactStart,
} from "./vendorSlice";

import {
  addNewVendorStart,
  addNewVendorSuccess,
  addNewVendorFailure,
} from "./vendorSlice";
import { showToast } from "../../../components";
function* fetchOneVendorSaga(action) {
  try {
    const vendor = yield call(fetchOneVendor, action.payload);
    yield put(getVendorOneSuccess(vendor.data));
  } catch (error) {
    yield put(getVendorOneFailure(error.message));
  }
}
function* fetchVendorsSaga(action) {
  try {
    const vendors = yield call(fetchVendors, action.payload);
    yield put(getVendorsSuccess(vendors));
  } catch (error) {
    yield put(getVendorsFailure(error.message));
  }
}
function* addNewVendorSaga(action) {
  try {
    const response = yield call(addNewVendor, action.payload);
    if (response.success) {
      yield put(addNewVendorSuccess(response.data));
      showToast("Vendor Added Successfully", "success", 3000);
    } else {
      yield put(addNewVendorFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(addNewVendorFailure(error.message));
  }
}
function* updateVendorSaga(action) {
  try {
    const { onSuccess, suppressToast = false, onError } = action.payload;

    const response = yield call(updateVendor, action.payload);
    if (response.success) {
      yield put(updateVendorSuccess(response.data.data));
      if (onSuccess) {
        onSuccess(response.data.data);
      }
      if (!suppressToast) {
        showToast("Vendor Updated Successfully", "success", 3000);
      }
    } else {
      yield put(updateVendorFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(updateVendorFailure(error.message));
  }
}
function* addNewContactSaga(action) {
  try {
    const { submissionData, onSuccess } = action.payload;
    const response = yield call(addContact, submissionData);
    console.log({ submissionData, onSuccess, response });
    if (response.success) {
      yield put(addContactSuccess(response.data));
      onSuccess();
      showToast("Added Contact Successfully", "success", 3000);
    } else {
      yield put(addContactFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(addContactFailure(error.message));
  }
}
function* updateContactSaga(action) {
  try {
    const response = yield call(updateContact, action.payload);
    if (response.success) {
      yield put(updateContactSuccess(response.data));
      showToast("Updated Contact Successfully", "success", 3000);
      yield put(updateContactSuccess(response.data));
    } else {
      showToast(`${response.error}`, "error", 3000);
      yield put(updateContactFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(updateContactFailure(error.message));
  }
}

export function* watchFetchVendors() {
  yield takeLatest(getVendorsStart.type, fetchVendorsSaga);
  yield takeLatest(addNewVendorStart.type, addNewVendorSaga);
  yield takeLatest(updateVendorStart.type, updateVendorSaga);
  yield takeLatest(addContactStart.type, addNewContactSaga);
  yield takeLatest(updateContactStart.type, updateContactSaga);
  yield takeLatest(getVendorOneStart.type, fetchOneVendorSaga);
}
